import { render, staticRenderFns } from "./PublicCollectingView.vue?vue&type=template&id=0542839e&scoped=true"
import script from "./PublicCollectingView.vue?vue&type=script&lang=js"
export * from "./PublicCollectingView.vue?vue&type=script&lang=js"
import style0 from "./PublicCollectingView.vue?vue&type=style&index=0&id=0542839e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542839e",
  null
  
)

export default component.exports